// extracted by mini-css-extract-plugin
export default {"container":"Bookmark_container__VLJwc"};